import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useEffect } from 'react';
import Image from '@Shared/Ui/Image';

function HeadlessModal(props) {
    const {
        show = false,
        centered = false,
        fullscreen = false,
        closeOnEsc = false,
        closeOnOverlayClick = false,
        afterLeave = () => {},
        onClose = () => {},
        children,
        closeIcon = true,
        ...attrs
    } = props;

    useEffect(() => {
        const onEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        if (closeOnEsc) {
            window.addEventListener('keydown', onEscape);
        }

        return () => {
            if (closeOnEsc) {
                window.removeEventListener('keydown', onEscape);
            }
        };
    }, [closeOnEsc, onClose]);

    const onClickOverlay = () => {
        if (closeOnOverlayClick) {
            onClose();
        }
    };

    return (
        <Transition appear show={show} as={Fragment}>
            <Dialog as='div' className='relative z-50' onClose={() => {}}>
                <Transition.Child
                    as={Fragment}
                    enter='duration-300 ease-out'
                    enterFrom='opacity-0'
                    enterTo='opacity-100'
                    leave='duration-200 ease-in'
                    leaveFrom='opacity-100'
                    leaveTo='opacity-0'
                    afterLeave={afterLeave}
                >
                    <div className='fixed inset-0 transform transition-all'>
                        <div
                            className={`absolute inset-0 ${!fullscreen ? 'bg-gray-500/75' : ''}`}
                            onClick={onClickOverlay}
                            onPointerDown={onClickOverlay}
                        />
                    </div>
                </Transition.Child>

                <div
                    className={`pointer-events-none fixed overflow-y-auto transition-opacity ${fullscreen ? 'inset-0' : 'inset-4'}`}
                >
                    <div
                        className={`flex ${centered && 'min-h-full items-center'} ${fullscreen ? 'min-h-full' : 'justify-center'}`}
                    >
                        <Transition.Child
                            as={Fragment}
                            enter='ease-out duration-300'
                            enterFrom='opacity-0 translate-y-4 sm:scale-95'
                            enterTo='opacity-100 translate-y-0 sm:scale-100'
                            leave='ease-in duration-200'
                            leaveFrom='opacity-100 translate-y-0 sm:scale-100'
                            leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                        >
                            <Dialog.Panel
                                {...attrs}
                                className={`pointer-events-auto relative overflow-clip ${fullscreen && 'w-full min-w-full'} ${attrs.className}`}
                            >
                                {!fullscreen && closeIcon && (
                                    <div
                                        onClick={onClose}
                                        className={'absolute right-0 top-0 p-2.5'}
                                    >
                                        <Image className='cursor-pointer' icon={'close'} />
                                    </div>
                                )}

                                {children}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}

export default HeadlessModal;
